// extracted by mini-css-extract-plugin
export default {"Leagues":"leagues_Leagues__H4gEQ","Display":"leagues_Display__y0tlp","Sidebar":"leagues_Sidebar__NU3h3","Hamburger":"leagues_Hamburger__ERKNF"};